#import ./CraftLink.graphql

fragment Storytelling on storytellingBlock_MatrixField {
    ... on storytellingBlockBlock_Entry {
        backgroundColor
        title: blockTitle
        description
        link: linkField {
            ... CraftLinkField
        }
        images {
            title
            alt
            url
            width
            height
            w113: url @transform(width: 113, format: "webp")
            w226: url @transform(width: 226, format: "webp")
            w314: url @transform(width: 314, format: "webp",) # motog4/pagespeed DPR 3.0 image
            w418: url @transform(width: 418, format: "webp")
            w836: url @transform(width: 836, format: "webp")
            w113_avif: url @transform(width: 113, format: "avif")
            w226_avif: url @transform(width: 226, format: "avif")
            w314_avif: url @transform(width: 314, format: "avif") # motog4/pagespeed DPR 3.0 image
            w418_avif: url @transform(width: 418, format: "avif")
            w836_avif: url @transform(width: 836, format: "avif")
        }
    }
}
